// Época Casera — carrito lateral propio de la landing.
// · Los botones de compra (form[data-ec-comprar]) ya no llevan a /cart: fijan la cantidad
//   del libro en 1 por /cart/update.js (tocar dos veces no duplica) y abren el drawer.
// · Extras ([data-ec-extra]) y "Quitar" ([data-ec-quitar]) actualizan el drawer en el lugar.
// · El HTML del drawer lo devuelve Shopify en la misma respuesta (sections: 'ec-carrito').
// Sin JS, el form sigue funcionando como antes (va a /cart).
(() => {
  if (window.__ecDrawer) return;
  window.__ecDrawer = true;

  const SECCION = 'ec-carrito';
  const root = document.querySelector('[data-ec-drawer]');
  if (!root) return;
  const panel = root.querySelector('.ec-dr__panel');
  const contenido = root.querySelector('[data-ec-drawer-contenido]');
  let ultimoFoco = null;

  const pintar = (html) => {
    if (!html) return;
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const cuerpo = tmp.querySelector('.ec-dr__cuerpo');
    contenido.replaceChildren(...(cuerpo ? [cuerpo] : tmp.childNodes));
  };

  const abrir = () => {
    if (!root.hidden && root.classList.contains('is-abierto')) return;
    ultimoFoco = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('ec-dr-lock');
    void root.offsetWidth; // fuerza el layout para que la transición arranque (sin depender de rAF)
    root.classList.add('is-abierto');
    panel.focus({ preventScroll: true });
  };

  const cerrar = () => {
    root.classList.remove('is-abierto');
    document.documentElement.classList.remove('ec-dr-lock');
    setTimeout(() => { if (!root.classList.contains('is-abierto')) root.hidden = true; }, 350);
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus({ preventScroll: true });
  };

  const pedir = async (url, body) => {
    const r = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: SECCION, sections_url: window.location.pathname }),
    });
    const res = await r.json();
    if (!r.ok || res.status) throw new Error(res.description || res.message || 'Error del carrito');
    if (res.sections && res.sections[SECCION]) pintar(res.sections[SECCION]);
    else await refrescar();
    return res;
  };

  const refrescar = async () => {
    const r = await fetch(`${window.location.pathname}?sections=${SECCION}`);
    const d = await r.json();
    pintar(d[SECCION]);
  };

  const error = (msg) => {
    const p = document.createElement('p');
    p.className = 'ec-dr__cargando';
    p.textContent = msg;
    contenido.prepend(p);
  };

  // Botón de compra de la landing → agrega sin salir de la página.
  document.addEventListener('submit', async (e) => {
    const form = e.target instanceof HTMLFormElement && e.target.matches('[data-ec-comprar]') ? e.target : null;
    if (!form) return;
    e.preventDefault();
    const id = form.querySelector('[name="id"]')?.value;
    const btn = form.querySelector('[type="submit"]');
    if (!id) return form.submit();
    btn?.setAttribute('aria-busy', 'true');
    abrir();
    try {
      await pedir('/cart/update.js', { updates: { [id]: 1 } });
    } catch (err) {
      console.error('[ec-drawer]', err);
      cerrar();
      form.submit(); // plan B: el camino viejo por /cart
      return;
    } finally {
      btn?.removeAttribute('aria-busy');
    }
  }, true);

  root.addEventListener('click', async (e) => {
    const t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    if (t.closest('[data-ec-drawer-cerrar]')) { e.preventDefault(); cerrar(); return; }

    const extra = t.closest('[data-ec-extra]');
    const quitar = t.closest('[data-ec-quitar]');
    const btn = extra || quitar;
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    e.stopPropagation();
    btn.setAttribute('aria-busy', 'true');
    const texto = btn.textContent;
    btn.textContent = extra ? 'Agregando…' : 'Quitando…';
    try {
      if (extra) await pedir('/cart/add.js', { items: [{ id: Number(extra.dataset.ecExtra), quantity: 1 }] });
      else await pedir('/cart/change.js', { id: quitar.dataset.ecQuitar, quantity: 0 });
    } catch (err) {
      console.error('[ec-drawer]', err);
      btn.removeAttribute('aria-busy');
      btn.textContent = texto;
      error('No pudimos actualizar el carrito. Probá de nuevo.');
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && root.classList.contains('is-abierto')) cerrar();
  });
})();
